module.exports = __webpack_public_path__ + "static/img/address.bd3c858.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/address.jpeg
// module id = cnqf
// module chunks = 0